export const getOffsetDate = (num, unit) => {
  const now = new Date();

  let date;
  if (unit === 'M') date = new Date(now.setMonth(now.getMonth() + num));
  else if (unit === 'Y') date = new Date(now.setFullYear(now.getFullYear() + num));
  return date;
};

